import {
    buildInvoiceRefLabel,
    InvoiceReference,
    MAX_INVOICE_REFERENCE_TEXT_LENGTH,
} from "@common/schemas/invoiceReference.schema";

export interface AskAboutInvoice {
    id: string;
    invoiceNumber?: string | null;
    counterparty?: { name: string } | null;
}

const toBounded = (value: string | null | undefined): string | null =>
    value ? value.slice(0, MAX_INVOICE_REFERENCE_TEXT_LENGTH) : null;

export function buildInvoiceReferences({
    taskId,
    invoices,
}: {
    taskId: string;
    invoices: AskAboutInvoice[];
}): InvoiceReference[] {
    return invoices.map((invoice) => {
        const invoiceNumber = toBounded(invoice.invoiceNumber);
        const customerName = toBounded(invoice.counterparty?.name);
        return {
            taskId,
            invoiceId: invoice.id,
            invoiceNumber,
            customerName,
            label: buildInvoiceRefLabel({ invoiceNumber, customerName }).slice(
                0,
                MAX_INVOICE_REFERENCE_TEXT_LENGTH,
            ),
        };
    });
}
